export enum CommissionStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
  SOLD = 'SOLD',
  NEW = 'NEW',
  RETURNED_TO_CUSTOMER = 'RETURNED_TO_CUSTOMER',
} 